module.exports = __webpack_public_path__ + "static/media/skor.7bff7862.svg";